import React, { createContext, useContext, useState, useEffect } from 'react';

const CMSContext = createContext(null);

export function CMSProvider({ children }) {
  const [pages, setPages] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [galleries, setGalleries] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchCMSData() {
      try {
        setLoading(true);
        // Fetch pages, testimonials, and galleries in parallel
        const [pagesRes, testimonialsRes, galleriesRes] = await Promise.all([
          fetch('https://api.dev.auxo.dk/public/content/pages'),
          fetch('https://api.dev.auxo.dk/public/content/testimonials'),
          fetch('https://api.dev.auxo.dk/public/content/gallery')
        ]);

        if (!pagesRes.ok || !testimonialsRes.ok || !galleriesRes.ok) {
          throw new Error('Kunne ikke hente data fra CMS');
        }

        const pagesData = await pagesRes.json();
        const testimonialsData = await testimonialsRes.json();
        const galleriesData = await galleriesRes.json();

        setPages(pagesData);
        setTestimonials(testimonialsData);
        setGalleries(galleriesData);
      } catch (err) {
        console.error('Fejl ved hentning af CMS-data:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    }

    fetchCMSData();
  }, []);

  const getPage = (key) => pages.find(p => p.key === key);
  const getGallery = (key) => galleries.find(g => g.key === key);

  return (
    <CMSContext.Provider value={{ pages, testimonials, galleries, getPage, getGallery, loading, error }}>
      {children}
    </CMSContext.Provider>
  );
}

export function useCMS() {
  const context = useContext(CMSContext);
  if (!context) {
    throw new Error('useCMS skal bruges inden for en CMSProvider');
  }
  return context;
}
